import { useEffect, useState } from "react";
import { listCodehook } from "../../../services/model/model-config-service";
import { useAppInfo } from "../../../helpers/hooks/common-hook";

export default function CodehookPanel({ toolData, setToolData }) {
	const { appId } = useAppInfo();
	const [codehookList, setCodehookList] = useState([]);
	const [loading, setLoading] = useState(false);

	const fetchList = async () => {
		setLoading(true);
		const { data } = (await listCodehook(appId)) || {};
		setCodehookList(Array.isArray(data) ? data : []);
		setLoading(false);
	};

	useEffect(() => {
		if (appId) fetchList();
	}, [appId]);

	return (
		<div>
			<div className="flex justify-between items-center mb-1">
				<label className="block text-sm font-semibold text-gray-800 dark:text-white">Function</label>
				<div className="flex items-center gap-2">
					<button
						type="button"
						onClick={fetchList}
						title="Refresh list"
						className="text-gray-400 hover:text-gray-700 transition-colors"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							strokeWidth={1.5}
							stroke="currentColor"
							className="w-4 h-4"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
							/>
						</svg>
					</button>
					<a
						href={`/app/${appId}/functions/create`}
						target="_blank"
						rel="noreferrer"
						className="text-xs text-blue-600 hover:underline font-medium"
					>
						Create Function
					</a>
				</div>
			</div>
			<select
				value={toolData.codehookId || ""}
				onChange={(e) => setToolData({ ...toolData, codehookId: e.target.value })}
				disabled={loading}
				className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-800 bg-white focus:outline-none focus:ring-2 focus:ring-primary dark:bg-gray-700 dark:border-gray-600 dark:text-white disabled:opacity-50"
			>
				<option value="">Select Codehook</option>
				{codehookList.map((cd) => (
					<option key={cd.codehookId} value={cd.codehookId}>
						{cd.codehookId}
					</option>
				))}
			</select>
		</div>
	);
}
